/* 
* ------------------监管信息--------------
*/
import HiggsPromise from '../../utils/higgsPromise';
let commonUrl = '/finance/portrait/penalaw/';

/* 
* ------------------上海证券交易所--------------
*/
/* 承诺履行 
*/
export function getSSEPromise(data) {
    return HiggsPromise({
        url: commonUrl + 'sh/promiseperfom',
        data: data
    });
}

/* 监管问询 
*/
export function getSSEEnquiry(data) {
    return HiggsPromise({
        url: commonUrl + 'sh/regularinquiry',
        data: data
    });
}

/* 监管措施 
*/
export function getSSEMeasures(data) {
    return HiggsPromise({
        url: commonUrl + 'sh/regularmeasure',
        data: data
    });
}

/* 
* ------------------深圳证券交易所--------------
*/

/* 承诺事项及履行情况 
*/
export function getSZSEDegree(data) {
    return HiggsPromise({
        url: commonUrl + 'sz/promiseperfom',
        data: data
    });
}

/* 监管函件
*/
export function getSZSEEnquiry(data) {
    return HiggsPromise({
        url: commonUrl + 'sz/regularinquiry',
        data: data
    });
}

/* 监管措施 
*/
export function getSZSEMeasures(data) {
    return HiggsPromise({
        url: commonUrl + 'sz/regularmeasure',
        data: data
    });
}

/* 处罚与处分记录 
*/
export function getSZSPunish(data) {
    return HiggsPromise({
        url: commonUrl + 'sz/punishment',
        data: data
    });
}

/* 
* ------------------证监会--------------
*/

/* 行政处罚 
*/
export function getCSRCAdminist(data) {
    return HiggsPromise({
        url: commonUrl + 'csrcxzcf',
        data: data
    });
}

/* 行政监管措施 
*/
export function getCSRCMeasures(data) {
    return HiggsPromise({
        url: commonUrl + 'csrcxzjg',
        data: data
    });
}

/* 海关总署高级认证和失信企业信息 
*/
export function getDistrustFirm(data) {
    return HiggsPromise({
        url: commonUrl + 'customscredit',
        data: data
    });
}

/* 保监局行政处罚 
*/
export function getPIBXZCF(data) {
    return HiggsPromise({
        url: commonUrl + 'qyxgcircxzcf',
        data: data
    });
}

/*  经营异常
*/
export function getAbnormal(data) {
    return HiggsPromise({
        url: commonUrl + 'qyxgjyyc',
        data: data
    });
}

/*  行政处罚
*/ 
export function administrative(data) {
    return HiggsPromise({
        url: commonUrl + 'xzcf',
        data: data
    });
}

/*  行政监管措施
*/
export function supervision(data) {
    return HiggsPromise({
        url: '/finance/portrait/fraud/analysis',
        data: data
    });
}

/*  问询历史
*/
export function inquiryHistory(data) {
    return HiggsPromise({
        url: '/finance/portrait/fraud/analysis',
        data: data
    });
}

/*  监管函件
*/
export function supervisionWords(data) {
    return HiggsPromise({
        url: commonUrl + 'sz/regularinquiry',
        data: data
    });
}

/*  欠税记录
*/
export function taxPunish(data) {
    return HiggsPromise({
        url: commonUrl + 'qyxgqyqs',
        data: data
    });
}

/*  海关处罚
*/
export function customPunish(data) {
    return HiggsPromise({
        url: commonUrl + 'customsxzcf',
        data: data
    });
}



// WEBPACK FOOTER //
// ./src/services/financialPicture/historyPunish.js